interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}
const WorkIcon = ({ width, height, fill }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
    >
      <mask
        id="mask0_3439_30900"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3439_30900)">
        <path
          d="M3.33268 17.5C2.87435 17.5 2.48199 17.3368 2.1556 17.0104C1.82921 16.684 1.66602 16.2917 1.66602 15.8333V6.66666C1.66602 6.20832 1.82921 5.81596 2.1556 5.48957C2.48199 5.16318 2.87435 4.99999 3.33268 4.99999H6.66602V3.33332C6.66602 2.87499 6.82921 2.48263 7.1556 2.15624C7.48199 1.82985 7.87435 1.66666 8.33268 1.66666H11.666C12.1243 1.66666 12.5167 1.82985 12.8431 2.15624C13.1695 2.48263 13.3327 2.87499 13.3327 3.33332V4.99999H16.666C17.1243 4.99999 17.5167 5.16318 17.8431 5.48957C18.1695 5.81596 18.3327 6.20832 18.3327 6.66666V15.8333C18.3327 16.2917 18.1695 16.684 17.8431 17.0104C17.5167 17.3368 17.1243 17.5 16.666 17.5H3.33268ZM3.33268 15.8333H16.666V6.66666H3.33268V15.8333ZM8.33268 4.99999H11.666V3.33332H8.33268V4.99999Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default WorkIcon;
